const LANDSCAPE = 16 / 9;
const PORTRAIT = 9 / 16;
const TOLERANCE = 0.02;
function near(value, target) {
    return Math.abs(value - target) / target <= TOLERANCE;
}
export function orientationOf(width, height) {
    if (!width || !height || width <= 0 || height <= 0)
        return null;
    const ratio = width / height;
    if (near(ratio, LANDSCAPE))
        return "landscape";
    if (near(ratio, PORTRAIT))
        return "portrait";
    return "custom";
}
export function aspectLabel(width, height) {
    const o = orientationOf(width, height);
    if (!o)
        return null;
    if (o === "landscape")
        return "16:9";
    if (o === "portrait")
        return "9:16";
    const g = gcd(width, height);
    return `${Math.round(width / g)}:${Math.round(height / g)}`;
}
function gcd(a, b) {
    return b === 0 ? a : gcd(b, a % b);
}
export const ORIENTATION_LABELS = {
    landscape: "Landscape 16:9",
    portrait: "Portrait 9:16",
    custom: "Custom",
};
export function orientationOfResolution(resolution) {
    if (!resolution)
        return null;
    const m = /(\d+)\s*[x×]\s*(\d+)/i.exec(resolution);
    if (!m)
        return null;
    return orientationOf(Number(m[1]), Number(m[2]));
}
const KIND_FILTERS = ["image", "video"];
export function matchesMediaFilters(file, filters) {
    if (filters.length === 0)
        return true;
    const kinds = filters.filter((f) => KIND_FILTERS.includes(f));
    const shapes = filters.filter((f) => !KIND_FILTERS.includes(f));
    if (kinds.length > 0) {
        const isVideo = file.contentType.startsWith("video/");
        const wanted = isVideo ? "video" : "image";
        if (!kinds.includes(wanted))
            return false;
    }
    if (shapes.length > 0) {
        if (!file.orientation)
            return false;
        if (!shapes.includes(file.orientation))
            return false;
    }
    return true;
}
export function dimensionLabel(width, height) {
    if (!width || !height)
        return null;
    return `${width}×${height}`;
}
export function purgeStateOf(purgeAt, now = Date.now()) {
    if (!purgeAt)
        return "none";
    const t = purgeAt instanceof Date ? purgeAt.getTime() : Date.parse(purgeAt);
    if (!Number.isFinite(t))
        return "none";
    return t <= now ? "overdue" : "scheduled";
}
export function purgeDateLabel(purgeAt) {
    if (!purgeAt)
        return null;
    const d = purgeAt instanceof Date ? purgeAt : new Date(purgeAt);
    if (Number.isNaN(d.getTime()))
        return null;
    return d.toISOString().slice(0, 10);
}
export function durationLabel(seconds) {
    if (seconds === null || seconds === undefined || seconds <= 0)
        return null;
    const total = Math.round(seconds);
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    const pad = (n) => n.toString().padStart(2, "0");
    return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
}
